const homePageTranslations = {
  welcomeCard: {
    title: "Let’s Make Today Your Best Yet.",
    action: "Start Out",
  },
  subscriptionCard: {
    title: "Subscription Ends At",
    action: "Upgrade Plan",
  },
  fillFormCard: {
    subtitle: "Your New Program Is Waiting.",
    title: "Kindly Fill Out Your Form.",
    action: "Fill Form",
  },
  startingPoint: {
    title: "Choose Your Starting Point.",
    nutritionCard: {
      title: "Nutrition Plan",
      action: "View Program",
    },
    workoutCard: {
      title: "Workout Plan",
      action: "View Program",
    },
    customerSupport: {
      title: "Customer Support",
      action: "Contact Support",
    },
  },
};

export default homePageTranslations;
